import { container } from '../../services/container'

export default {

	check (to, from, next) {

    var user = container.get('user')
    const userSubscribed = () => user && user.isSubscribed()

    if (container.get('source').getValue() !== 'galbani') {

      next();
      return;
    }

		if (to.name === 'home') {

      return next(!userSubscribed() ? { name: 'how-it-works/galbani' } : true)
		}

    if (to.name === 'how-it-works') {
      return next({ name: 'how-it-works/galbani' })
    }

    if (to.name === 'privacy-policy') {
      return next({ name: 'privacy-policy/galbani' })
    }

    if (to.name === 'cookies-policy') {
      return next({ name: 'cookies-policy/galbani' })
    }

    next();
	},

}
